import isEmpty from "lodash-es/isEmpty";
import {
  emailJoin,
  emailSplit
} from "../components/RulesUI/Constraints/utils/notificationConstraints.utils";
import { RuleType } from "@certa/studio-core/src/constants/rules.constants";

/**
 * Forward parses the rule actions for deployable json
 */
export const ruleActionSerialize = (
  ruleActions: Record<string, any>,
  ruleType: RuleType
) => {
  let action: Record<string, any> = ruleActions;
  if (ruleType === RuleType.Notification) {
    const {
      tag,
      name,
      step,
      trigger,
      template,
      /* eslint-disable @typescript-eslint/naming-convention  */
      to_emails_static,
      to_emails_dynamic,
      cc_emails_static,
      cc_emails_dynamic,
      bcc_emails_static,
      bcc_emails_dynamic,
      attachment_fields,
      /* eslint-enable @typescript-eslint/naming-convention */
      ...rest
    } = ruleActions;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { to_emails, cc_emails, bcc_emails } = emailJoin(
      {
        to_emails_static,
        to_emails_dynamic,
        cc_emails_static,
        cc_emails_dynamic,
        bcc_emails_static,
        bcc_emails_dynamic
      },
      ["to_emails", "cc_emails", "bcc_emails"],
      true
    );

    action = {
      ...rest,
      tag,
      name,
      step,
      trigger,
      template,
      attachment_fields
    };
    if (!isEmpty(to_emails)) action.to_emails = to_emails;
    if (!isEmpty(cc_emails)) action.cc_emails = cc_emails;
    if (!isEmpty(bcc_emails)) action.bcc_emails = bcc_emails;
  }
  return action;
};

/**
 * Reverse parses the rule actions for meta json
 */
export const ruleActionDeserialize = (
  ruleActions: Record<string, any>,
  ruleType: RuleType
) => {
  let action: Record<string, any> = ruleActions;
  if (ruleType === RuleType.Notification) {
    const {
      tag,
      name,
      step,
      trigger,
      template,
      /* eslint-disable @typescript-eslint/naming-convention */
      to_emails,
      cc_emails,
      bcc_emails,
      attachment_fields,
      /* eslint-enable @typescript-eslint/naming-convention */
      ...rest
    } = ruleActions;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { to_emails_static, to_emails_dynamic } = emailSplit(
      to_emails,
      "to",
      true
    );
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { cc_emails_static, cc_emails_dynamic } = emailSplit(
      cc_emails,
      "cc",
      true
    );
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { bcc_emails_static, bcc_emails_dynamic } = emailSplit(
      bcc_emails,
      "bcc",
      true
    );

    action = {
      ...rest,
      tag,
      name,
      step,
      trigger,
      template,
      to_emails_static: to_emails_static.join(),
      to_emails_dynamic,
      cc_emails_static: cc_emails_static.join(),
      cc_emails_dynamic,
      bcc_emails_static: bcc_emails_static.join(),
      bcc_emails_dynamic,
      attachment_fields
    };
  }
  return action;
};
